import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const withdraw = createAsyncThunk(
  "withdraw",
  async (payload, thunkAPI) => {
    try {
     
      const response = await api.post("withdrawal", payload, {
        // headers: {
        //   'Content-Type': 'multipart/form-data',
        // }
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const withdrawSlice = createSlice({
  name: "withdraw",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(withdraw.pending, (state) => {
        state.loading = true;
      })
      .addCase(withdraw.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(withdraw.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default withdrawSlice.reducer;
